const tableTd = "_table-td_1wtme_1";
const styles = {
	tableTd: tableTd
};

export { styles as s };
//# sourceMappingURL=TableTd.module-VWX0ir3B.mjs.map
